import * as yup from 'yup';

const useValidationSchema = () => {
  const TagFormSchema = yup.object().shape({});

  return { TagFormSchema };
};

export default useValidationSchema;
